<script lang="ts">
	export let dark: boolean;
	export let text: string =
		' Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi, quod?';
	export let isHTML = false;
	export let maxWidth: string | number = 'auto';
	export let minWidth: string | number = 250;
	export let textAlign: 'left' | 'center' | 'right' = 'left';
</script>

<div
	class={`tooltip-wrapper ${$$props.class}`}
	class:dark
	style="min-width: {minWidth}px; max-width: {maxWidth}px;"
>
	{#if !isHTML}
		<p class="tooltip-text" style="text-align: {textAlign}">{text}</p>
	{:else}
		<div class="tooltip-text" style="text-align: {textAlign}">{@html text}</div>
	{/if}
</div>

<style lang="scss">
	@import 'tooltip';
</style>
